import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '../../state/settings/settings.service';
import { UserService } from '../../state/user/user.service';
import { CompanyService } from '../../state/company/company.service';
import { ClinicDetailService } from '../../state/clinic-detail/clinic-detail.service';
import { NavController } from '@ionic/angular';
import { ClinicDetailQuery } from '../../state/clinic-detail/clinic-detail.query';
import { SettingsQuery } from '../../state/settings/settings.query';
import { UserQuery } from '../../state/user/user.query';
import { Observable } from 'rxjs';
import { UserState } from '../../state/user/user.store';
import { ClinicDetailState } from '../../state/clinic-detail/clinic-detail.store';
import { LibraryService } from '../../../core/services/library/library.service';
import { RouterService } from '../../../core/services/router/router.service';

export class FlowwerInitializaterComponent {
    params$;
    queryParams$;
    clinic$: Observable<ClinicDetailState>;
    user$: Observable<UserState>;
    systemKeyParam;
    clinicIdParam;
    isLoadingContent = false;
    partentSystemKeyQueryParam;

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected settingsService: SettingsService,
        protected userService: UserService,
        protected companyService: CompanyService,
        protected clinicDetailService: ClinicDetailService,
        protected navCtrl: NavController,
        protected clinicDetailQuery: ClinicDetailQuery,
        protected settingsQuery: SettingsQuery,
        protected userQuery: UserQuery,
        protected libraryService: LibraryService,
        protected routerService: RouterService
    ) {}

    /** Inicializar la Company, Clinic y User */
    protected async initializeCompanyClinicUser(redirectIfLogged = false) {
        /** Obtenemos los parámetros de entrada */
        this.params$ = this.activatedRoute.params.subscribe((params) => {
            this.systemKeyParam = params.systemKey;
            this.settingsService.updateSystemKeyURL(params.systemKey);
            this.clinicIdParam = params.clinicId;
        });

        this.queryParams$ = this.activatedRoute.queryParams.subscribe(
            (params) => {
                if (params.parentSystemKey) {
                    this.partentSystemKeyQueryParam = params.parentSystemKey;
                    this.settingsService.updateParentSystemKey(
                        this.partentSystemKeyQueryParam
                    );
                } else {
                    this.settingsService.updateParentSystemKey('');
                }
                if (params.tokenId) {
                    this.userService.updateTokenIdAux(params.tokenId);
                }
            }
        );

        this.clinic$ = this.clinicDetailQuery.select();
        this.user$ = this.userQuery.select();

        /** cargamos i18n customizado */
        this.libraryService.loadOfflineCustomLibrary();
        this.companyService.updateOfflineCustomLibraryLoaded(true);

        try {
            /** Comprobamos si tenemos la company cargada para cargarla */
            await this.companyService.checkCompanyAndInit(
                this.partentSystemKeyQueryParam !== ''
                    ? this.partentSystemKeyQueryParam
                    : null
            );
        } catch (e) {
            this.navCtrl.navigateRoot('/not-found');
            throw e;
        }
        try {
            await this.clinicDetailService.checkClinicAndInit(
                this.systemKeyParam,
                this.clinicIdParam
            );
        } catch (e) {
            // TODO: Problema con las redirecciones rápidas: Al ir a / y luego redirifir rápido de nuevo al user tabs, se crea el nuevo componente antes de destriurse el anterior, y hace que se borre todo Akita
            this.navCtrl.navigateRoot('/');
            throw e;
        }

        try {
            await this.userService.checkUserAndLoad(false, true);
        } catch (e) {
            this.routerService.goToMainTabWithoutLogin();
            throw e;
        }

        // Esto nos sirve para evitar que se entre al registro estando logeados
        if (redirectIfLogged) {
            if (this.userQuery.tokenId !== '') {
                this.navCtrl.navigateBack([
                    '/' +
                        this.settingsQuery.systemKeyURL +
                        '/' +
                        this.clinicDetailQuery.id +
                        '/details',
                ]);
            }
        }
    }

    /** Inicializar la Company y Clinic */
    protected async initializeCompanyUserPersonalized() {
        /** Obtenemos los parámetros de entrada */
        this.params$ = this.activatedRoute.params.subscribe((params) => {
            if (params.systemKey) {
                this.settingsService.updateSystemKeyURL(params.systemKey);
            }
        });

        this.queryParams$ = this.activatedRoute.queryParams.subscribe(
            (params) => {
                if (params.parentSystemKey) {
                    this.partentSystemKeyQueryParam = params.parentSystemKey;
                    this.settingsService.updateParentSystemKey(
                        this.partentSystemKeyQueryParam
                    );
                } else {
                    this.settingsService.updateParentSystemKey('');
                }
                if (params.tokenId) {
                    this.userService.updateTokenIdAux(params.tokenId);
                }
            }
        );

        /** cargamos i18n customizado */
        this.libraryService.loadOfflineCustomLibrary();
        this.companyService.updateOfflineCustomLibraryLoaded(true);

        try {
            await this.companyService.checkCompanyAndInit(
                this.partentSystemKeyQueryParam !== ''
                    ? this.partentSystemKeyQueryParam
                    : null
            );
        } catch (e) {
            this.navCtrl.navigateRoot('/not-found');
            throw e;
        }
        /** Comprobamos el login del usuario (SIN CARGARLO EN AKITA) */
        await this.userService.checkUser();
    }

    /** Desuscribirse de los parámetros de ruta y query Params */
    protected unsuscribeParamsQueryParams() {
        this.params$.unsubscribe();
        this.queryParams$.unsubscribe();
    }
}
